<path
    d="M9.99993 1.66663L12.2041 6.96615L17.9254 7.42482L13.5664 11.1588L14.8981 16.7418L9.99993 13.75L5.10172 16.7418L6.43347 11.1588L2.07446 7.42482L7.79574 6.96615L9.99993 1.66663Z"
    fill="currentColor"
/>
